/**
 * @deprecated
 */
import $ from 'jquery';

//shimované pluginy většinou nemají export, většinou extendují jQuery object
//require('fg-frontend/ramjet/liveValidation');
//require('fg-frontend/ramjet/partialUpdate');
require('./third/bootstrap/js/collapse');
require('./third/bootstrap/js/carousel');
require('./third/bootstrap/js/transition');
require('./third/bootstrap/js/tab');
require('./third/fancyBox/source/jquery.fancybox');
require('./third/jquery-ui/ui/effect-slide');
require('./third/jquery.cookie/jquery.cookie');
require('./third/jquery.propeller');
// require('./web/jquery.webslider');
require('./web/jquery.socialshare');
require('./web/jquery.cookie');
require('./highslide/highslide-settings');
// import cookiesPolicy from 'fg-frontend/components/CookiesPolicy4/index';


// var GoogleRecaptcha = require('./web/GoogleRecaptcha');

var MapRenderer = require('./map/renderer');
var NextPageLoader = require('./web/nextPageLoader');


$(window).on("resize", function() {
	headerSearchingForm();
	// setCarouselSwitching();
});


// Load more News
var nextPageLoader = new NextPageLoader('[data-ride=next-page-loader]', '[data-load=next]');
nextPageLoader.init();

// Links out
$('a[target="_blank"]').addClass('link-out');

//social share
$('.socialShare').socialShare();

var fancyBoxLocale = {
	'cs': {
		'close' : 'Zavřít',
		'next' : 'Následující',
		'previous' : 'Předchozí',
		'error' : 'Zkuste to prosím znovu později.'
	},
	'en': {
		'close' : 'Close',
		'next' : 'Next',
		'previous' : 'Previous',
		'error' : 'Please try again later.'
	},
	'ru': {
		'close' : 'близко',
		'next' : 'следующий',
		'previous' : 'предыдущий',
		'error' : 'Пожалуйста, попробуйте позже.'
	},
	'de': {
		'close' : 'Schließen',
		'next' : 'Nächster',
		'previous' : 'Vorherig',
		'error' : 'Bitte versuche es später erneut.'
	},
	'jp': {
		'close' : 'Close',
		'next' : 'Next',
		'previous' : 'Previous',
		'error' : 'Please try again later.'
	}
}

// Fancybox
$('.js-fancybox').fancybox({
	loop: false,
	helpers : {
		title : {
			type : 'inside'
		}
	},
	beforeShow : function(){
		this.title =  this.title ? '<b>'+ this.title +'</b><br/>'+ ($(this.element).data("caption") ? $(this.element).data("caption") : '') : null;
		if (!this.title && $(this.element).data("caption")) {
			this.title = $(this.element).data("caption");
		}
	},
	tpl: {
		error    : '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
		closeBtn : '<a title="' + fancyBoxLocale[window.projectConfig.lang].close + '" class="fancybox-item fancybox-close" href="javascript:;"></a>',
		next     : '<a title="' + fancyBoxLocale[window.projectConfig.lang].next + '" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
		prev     : '<a title="' + fancyBoxLocale[window.projectConfig.lang].previous + '" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'
	}
});

// Responsive tables
$('.content').find('.table').each(function(i) {
	$(this).wrap('<div class="table-responsive"></div>');
});

// Search form
$(function(){
	headerSearchingForm();
});

function headerSearchingForm() {
    $('.form-search').each(function() {
        var $t = $(this);
        var searchWrap = $t.find('.form-search__input-group');
        var searchInput = $t.find('.form-search__input');
        var isOpened = $t.data('opened') === '1';

        $t.off('click', '.form-search__btn');
        $t.off('click', '.form-search__close');
        searchWrap.removeAttr('style');
        $t.data('opened', '0').removeClass('form-search--opened');

        if ($('.header-mobile-btn').is(':hidden') || isOpened) {
            var bindClick = function() {
                $t.on('click', '.form-search__btn', function(e) {
                    e.preventDefault();
                    if (isOpened) {
                        if (searchInput.val() !== '') {
                            $t.off('click', '.form-search__btn');
                        }
                    } else {
                        $t.data('opened', '1').addClass('form-search--opened');
                        searchWrap.show("slide", { direction: "right" }, 500, function() {
                            searchInput[0].focus();
                            $t.off('click', '.form-search__btn');
                        }).css("display", "flex");
                    }
                });
            };
            bindClick();

            $t.on('click', '.form-search__close', function() {
                searchWrap.hide("slide", { direction: "right" }, 400);
                bindClick();
                setTimeout(function() {
                    $t.data('opened', '0').removeClass('form-search--opened');
                }, 500);
            });
        }
    });
}


// Languages
setSwitchingLanguages();

function setSwitchingLanguages() {
	$(document).on('click', '.langs .langs-arrow, .langs .lang.active', function(e) {
		e.preventDefault();
		$('.langs').toggleClass('all-langs-visible');
		$('.langs li:not(".active")').slideToggle();
	});
}

// Filter tabs - filter by class
/*
$('.js-filter').each(function() {
	var $t = $(this);

	$t.on('click', '[data-filter-target]', function(e, eventType) {
		e.preventDefault();
		var target = $(this).data('filterTarget');
		var filterElement = $t.find('[data-filter='+ $(this).data('filterTargetElement') +']');
		var links = $t.find('[data-filter-target][data-filter-target-element='+ $(this).data('filterTargetElement') +']');

		if (target) {
			filterElement.hide().removeClass('item-visible').css('clear', 'none');
			$t.find('.filter-hide').hide();
			$t.find(target).fadeIn(300);
			// clearovani kvuli seznamu produktu
			$t.find(target).filter(':even').css('clear', 'both');

			// scroll to target
			if (eventType == 'click') {
				$('html,body').animate({
					scrollTop: $t.find(target).offset().top
				}, 300);
			}
		} else {
			filterElement.hide().fadeIn(300).css('clear', 'none').filter(':even').css('clear', 'both');
			$('html,body').animate({
				scrollTop: filterElement.offset().top
			}, 300);
		}

		links.parent().removeClass('active');
		$(this).parent().addClass('active');

		// svg world map
		if ($('.svg-map-world').length > 0) {
			var continent = target.replace('.filter-', '').replace('-continent', '');
			if ($('.svg-map-world').find('path#'+ continent).length > 0) {
				$('.svg-map-world').find('path').removeAttr('style');
				$('.svg-map-world').find('path#'+ continent).css('fill', '#f15e10');

				if ($('body').hasClass('gmeinder')) {
					$('.svg-map-world').find('path#'+ continent).css('fill', '#39b2ea');
				}
			}

		}
	});

	$t.find('.nav .active a').trigger('click','filter');
});
*/


/**
 * SVG world map clickable
$('path', $('.svg-map-world')).on('click', function() {
	var el = $(this);
	var target = el.attr('id');
	$('.js-filter').find('[data-filter-target=".filter-'+ target +'-continent"]').trigger('click');
	var filterOffset = $('.js-filter').offset().top;
	$('body, html').animate({
		scrollTop: filterOffset
	}, 300);
});
 */


// Animovany scroll na kotvu
$('a.animate-scroll').bind('click', function(e) {
	e.preventDefault();
	var target = $(this.hash);
	if (target.length) {
		$('html,body').animate({
			scrollTop: target.offset().top
		}, 300);
		return false;
	}
});


// Google map
$.each($('.map'), function () {
	var gmap = new MapRenderer();
	gmap.decorate($(this));
	var center = gmap.map.getCenter();
});

// Google mapy v kontaktech
//$(document).on('click', '.googlemap-content__inactive', function(e){
//	$(e.currentTarget).removeClass('googlemap-content__inactive');
//	$(document).trigger('removeInactiveGoogleMapOnHomepage');

	 $.each($('.gmap'), function () {
		 var gmap = new MapRenderer();
		 gmap.decorate($(this));
		 var center = gmap.map.getCenter();
	 });
//});


/* Styled file select
$(document).on('change', '.btn-file :file', function() {
	var input = $(this),
		numFiles = input.get(0).files ? input.get(0).files.length : 1,
		label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
	input.trigger('fileselect', [input, numFiles, label]);
});
$(document).on('fileselect', function(event, input, numFiles, label) {
	var log = numFiles > 1 ? numFiles + ' files selected' : label;
	if(input.length) {
		input.parents('.form-group').find('.file-label').html(log);
	}
});
*/

$(document).on('click', '#exportToPdfModal, #sendByEmailModal, #exportToPdfTrigger, #exportToPdfClose, #sendToEmailTrigger, #sendToEmailClose, #saveToPdfTrigger, #saveToPdfClose', function(e) {
	e.preventDefault();
});

//filtr pro volné pozice
function careerFilter(city) {
	$('.vacanciesList ul li').each(function() {
		$(this).hide();
		var content = $(this).text();
		if ( city == 'all' ) {
			$(this).show();
		} else if ( content.indexOf(city) > -1 ) {
			$(this).show();
		}
	});

	$('.vacanciesList ul').each(function() {
		var liIsVisible = false;
		$('li', this).each(function() {
			if ($(this).is(':visible')) {
				liIsVisible = true;
			}
		});
		if ( liIsVisible == false ) {
			$(this).prev().hide();
		} else {
			$(this).prev().show();
		}
	});
}

$(document).on('change', '.vacanciesFilter input[type="radio"]', function() {
	var city = $(this).data('city');
	careerFilter(city)
});

$('.vacanciesFilter').each(function() {
	var hash = window.location.hash.slice(1);
	if ( hash.length > 0 ) {
		$('input[type="radio"]', this).each(function() {
			if ( hash == $(this).data('hash')) {
				$(this).attr('checked', 'checked');
				careerFilter($(this).data('city'));
			}
		});
	}
});

/**
 * Carousel - Image zooming inside carousel on HP
;(function(){
	//Set the first element to animate
	$(".main-carousel .carousel-inner .item.active img, .main-carousel .carousel-inner .item.active .carouselImgCnt").addClass("smooth-transition2500");

	//After slide change
	$(".main-carousel").on("slid.bs.carousel", function(e){
		$(".main-carousel .carousel-inner .item:not(.active) img, .main-carousel .carousel-inner .item:not(.active) .carouselImgCnt").removeClass("smooth-transition5000");
	});

	//Before slide change
	$(".main-carousel").on("slide.bs.carousel", function(e){
		var $nextItem = $(e.relatedTarget);
		window.setTimeout(function(){
			$nextItem.find("img").addClass("smooth-transition2500");
			$nextItem.find(".carouselImgCnt").addClass("smooth-transition2500");
		},300);
		var sliderHeight =  $(e.target).find(".slider").height();
		$(e.target).find(".slider, .carousel-inner, .slider ul:first").css('height', sliderHeight+'px');
		$(e.target).find("li.active").removeClass('active');
		$(e.target).find('li[data-slide-to="'+ $(e.relatedTarget).index('.item')+'"]').addClass('active ease-effect');
	});

	$('.gearboxes-carousel').each(function() {
		var self = this;
		var startTouch = null;
		var endTouch = null;

		$(this).on('touchstart', function(e) {
			startTouch = e.originalEvent.touches[0].pageX;
		});

		$(this).on('touchmove', function(e) {
			endTouch = e.originalEvent.touches[0].pageX;
		});

		$(this).on('touchend', function(e) {
			if ( Math.abs(endTouch - startTouch) > 100 ) {

				var itemLength = $('ul', this).size();
				var activeItem = $('li.active', this).index();
				var activeItemIncreased = activeItem + 1;
				if ( activeItemIncreased == itemLength ) {
					activeItemIncreased = 0;
				}
				var activeItemDecreased = activeItem - 1;
				if ( activeItemDecreased < 0 ) {
					activeItemDecreased = itemLength - 1;
				}

				if ( endTouch < startTouch ) {
					$('.carousel-inner > div').removeClass('active');
					$('.carousel-inner > div:eq(' + activeItemIncreased + ')').addClass('active');
					window.setTimeout(function(){
						$('.carousel-inner > div:eq(' + activeItemIncreased + ')').find("img").addClass("smooth-transition2500");
					},300);
					$(self).find("li.active").removeClass('active');
					$(self).find('li[data-slide-to="'+ activeItemIncreased +'"]').addClass('active ease-effect');
				} else if ( endTouch > startTouch) {
					$('.carousel-inner > div').removeClass('active');
					$('.carousel-inner > div:eq(' + activeItemDecreased + ')').addClass('active');
					window.setTimeout(function(){
						$('.carousel-inner > div:eq(' + activeItemDecreased + ')').find("img").addClass("smooth-transition2500");
					},300);
					$(self).find("li.active").removeClass('active');
					$(self).find('li[data-slide-to="'+ activeItemDecreased +'"]').addClass('active ease-effect');
				}
				startTouch = null;
				endTouch = null;
			}
		});
	});
})();
 */

//setCarouselSwitching();

/* Na mobilu jed primo na odkaz
function setCarouselSwitching() {
	$('.main-carousel').find('.carousel-nav li').off('click.carouselSwitch');
} */
/*
var carouselMouseEnterTimeout;
var carouselMouseOutTimeout;
$(document).on('mouseenter', '.carousel-nav li', function(e) {
	e.preventDefault();
	//var parent = $(this).parent();
	var target = $(this).data('target');
	var self = this;
	clearTimeout(carouselMouseOutTimeout);
	carouselMouseEnterTimeout = setTimeout(function() {
		//$('.main-carousel img').removeClass('smooth-transition2500');
		//$('.main-carousel li').removeClass('active ease-effect');
		$(self).trigger('click');
	}, 200);

});

$(document).on('mouseleave', '.carousel-nav li', function() {
	clearTimeout(carouselMouseEnterTimeout);
});

$(document).on('click', '.carousel-nav li a', function() {
	location.href = $(this).attr('href');
});

$(window).on('load', function() {
	//setCarouselHeight();
});
$(window).on('resize', function() {
	//setCarouselHeight();
});
*/

/**
 * Collapse blocks
 */
$('.collapse-block').each(function() {
	var $t = $(this);
	var content = $t.find('.collapse-content');

	$t.find('.collapse-click').on('click', function() {
		if ($t.hasClass('closed')) {
			if (content.length > 0 ) {
				// Animuji collapse-content
				content.slideDown(200);
				$t.removeClass('closed').addClass('opened');
			} else {
				// Animuji collapse-block
				$t.removeClass('closed').hide().addClass('opened').slideDown(200);
			}
		} else {
			if (content.length > 0 ) {
				// Animuji collapse-content
				content.slideUp(200);
				$t.removeClass('opened').addClass('closed');
			} else {
				// Animuji collapse-block
				$t.slideUp(200, function() {
					$t.removeClass('opened').addClass('closed').show();
				});
			}
		}
	});
});


/**
 * Scroll to first error after partial update
 */
$(document).on('afterContentsReplaced', function(e) {
	var dynContent = $(e.target);
	if (dynContent.find('.has-error').length > 0) {
		$('html,body').animate({
			scrollTop: dynContent.find('.has-error').eq(0).offset().top
		}, 300);
	} else {
		$('.btn-top__link').trigger('click');
	}

	sortDownloadTable();
});

/*
function setCarouselHeight() {
	$(".main-carousel").each(function() {
		var sliderHeight = $('.slider img:visible', this).height();
		$('.slider, .carousel-inner, .slider ul:first', this).css({'height' : sliderHeight + 'px'});
	});
}
*/

/**
 * Go to Top - from Animate Standard
 */

$(window).scroll(function (e) {
	if (!($('body').hasClass('printedMatters'))) {
		checkScrollTopFixInFooterButton();
		checkScrollTopButton();
	}
});

if (!($('body').hasClass('printedMatters'))) {
	checkScrollTopFixInFooterButton();
	checkScrollTopButton();
}

function checkScrollTopFixInFooterButton(){
	var $footer = $(".js_btnScrollTopFixInFooter-footer");
	var $button = $(".js_btnScrollTopFixInFooter-button");

	if (elementInViewport($footer[0])) {
		$button.addClass("in-footer");
	} else {
		$button.removeClass("in-footer");
	}
}

function elementInViewport(el) {
    if(el) {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;

        while(el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
            top < (window.pageYOffset + window.innerHeight) &&
                left < (window.pageXOffset + window.innerWidth) &&
                (top + height) > window.pageYOffset &&
                (left + width) > window.pageXOffset
        );
    }
}

function checkScrollTopButton(){
	var top = $(document).scrollTop();

	if (top > 100) {
		$(".js_btnScrollTop").stop().fadeIn(250);
	} else {
		$(".js_btnScrollTop").stop().fadeOut(250);
	}
}

// Default value in industry filter
$('.industry-filter .form-group input:eq(0)').prop('checked','checked');

/**
 * Get GET hash values from any string
 */
window.getHashValues = function getHashValues(string) {
	var result = {};
	var oldKey;
	string.replace(/[#&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
		if (oldKey != key) {
			result[key] = value;
			oldKey = key;
		} else {
			result[key] = typeof(result[key]) == 'string' ? [result[key]] : result[key];
			result[key].push(value);
			oldKey = key;
		}
	});
	return result;
};

/* / Gearbox rotation
function gearboxRotation(el,id) {
	var $container = el;
	var $select = $('.gearbox-positioning');
	$container.find('.gearbox-rotation-input').bind('change keyup', function() {
		var angle = parseInt($(this).val());
		var negativeAngle = angle * -1;
		if (angle >= -180 && angle <= 180) {
			if (angle <= 0 && angle >= -180) {
				var transformedAngle = -180 - angle;
				$container.find('.gearbox-rotation .in').css('background-image', 'linear-gradient(0deg, transparent 50%, #dde5ec 50%),linear-gradient('+transformedAngle+'deg, #f15e10 50%, transparent 50%)');
			}
			if (angle >= 0 && angle <= 180) {
				$container.find('.gearbox-rotation .in').css('background-image', 'linear-gradient(180deg, transparent 50%, #dde5ec 50%),linear-gradient('+negativeAngle+'deg, #f15e10 50%, transparent 50%)');
			}

			$container.find('.gearbox-rotation .gear').css('transform', 'rotate('+negativeAngle+'deg)');
			$container.find('.gearbox-rotation .pointer').css('transform', 'rotate('+negativeAngle+'deg)');
		} else {
			$container.find('.gearbox-rotation .in').css('background-image', 'none');
			$container.find('.gearbox-rotation .gear').css('transform', 'rotate(0deg)');
			$container.find('.gearbox-rotation .pointer').css('transform', 'rotate(0deg)');
		}

		if (id == 0) {
			if ((angle <= 5 && angle >= -5) || (angle <= -175) || (angle >= 175)) {
				$('option:eq(0)', $select).prop('selected','selected');
			}
			else if (angle == -90) {
				$('option:eq(1)', $select).prop('selected','selected');
				//$container.find('.gearbox-rotation-input').trigger('requestValidation');
			}
			else if (angle == 90) {
				$('option:eq(2)', $select).prop('selected','selected');
				//$container.find('.gearbox-rotation-input').trigger('requestValidation');
			}
			//if (!(angle == 90 || angle == -90)) {
			else {
				$('option:eq(3)', $select).prop('selected','selected');
				//$container.find('.gearbox-rotation-input').trigger('requestValidation');
			}
			$container.find('.gearbox-rotation-input').trigger('requestValidation');
		}
	});

	if (id == 0) {
		$select.change(function() {
			if ($('option:eq(0)', $select).prop('selected')) {
				//$container.find('.gearbox-rotation-input').val(0);
				$('#gearboxAngle1').val(0).change();
			}
			if ($('option:eq(1)', $select).prop('selected')) {
				//$container.find('.gearbox-rotation-input').val(-90);
				$('#gearboxAngle1').val(-90).change();
			}
			if ($('option:eq(2)', $select).prop('selected')) {
				//$container.find('.gearbox-rotation-input').val(90);
				$('#gearboxAngle1').val(90).change();
			}
			//$container.find('.gearbox-rotation-input').trigger('change');
		});
	}

	$container.find('.draggable-layer').propeller({
		onRotate: function() {
			var angle = Math.floor(this.angle) * -1;
			if (angle < -180) angle = 360 + angle;
			$container.find('.gearbox-rotation-input').val(angle).trigger('change');
		}
	});
	$container.find('.gearbox-rotation-input').trigger('change');
}
$('.gearbox-rotation-container').each(function(i) {
	gearboxRotation($(this),i);
});
*/

/* / Login
$('.log-in-button').click(function() {
	$(this).parent().toggleClass('active');
});
$('.log-in .icon-cancel').click(function() {
	$(this).closest('.log-in').removeClass('active');
});

$(document).on('keypress', '.wizard form', function(e) {
	if ( e.keyCode == 13 ) {
		e.preventDefault();
		var inputs =   $(e.target).parents("form").eq(0).find(":input:visible"),
			idx = inputs.index(e.target);
		if (idx == inputs.length - 1) {
			inputs[0].select()
		} else {
			inputs[idx + 1].focus();
			inputs[idx + 1].select();
		}
	}
});
*/

$('.speed-disabled-input').each(function() {
	var speedDisabledInterval = setInterval(function() {
		if ( $('.gearbox-side input[value="1"]').is(':checked') && $('.speed-disabled-input').val != '0' ) {
			var val = $('.speed-disabled-input strong').text().trim();
			$('.speed-input-display-span').text('1/');
			$('.speed-disabled-input').addClass('activated');
		} else {
			$('.speed-input-display-span').text('');
			$('.speed-disabled-input').removeClass('activated');
		}
	}, 1000);
});

// button area - wizard
$('.wizard .button-area > div').click(function() {
	$(this).find('input').click();
});

$(document).on('click', '.configuratorHeadingToggle', function() {
	var parent = $(this).parent();
	$('.configuratorSectionCntIn', parent).slideToggle();
	$(this).toggleClass('opened');
});

/**
 * Sort files by lang in download center
 */
sortDownloadTable();
function sortDownloadTable() {
	$('.js_section-download').each(function() {
		var $ul = $(this);
		// make two-way relations
		$(this).find('[data-relfiles]').each(function() {
			var relfiles = $(this).data('relfiles');
			var $actualFile = $(this);
			$.each(relfiles, function(i, v) {
				var $file = $ul.find('.primary-lang#file-'+v);
				if ($file.length && !$file.attr('data-relfiles')) {
					var relfilesClone = relfiles.slice(0);
					var removeIndex = relfilesClone.indexOf(v);
					if (removeIndex > -1) {
						relfilesClone.splice(removeIndex, 1);
						relfilesClone.push($actualFile.attr('id').replace('file-',''));
						$file.attr('data-relfiles','['+relfilesClone+']');
					}
				}

			});
		});
		// primary lang on top
		$(this).find($('.primary-lang').get().reverse()).each(function() {
			$(this).prependTo($ul);
		});
		// related items
		$(this).find('li').each(function() {
			if ($(this).attr('data-relfiles') && (!$(this).hasClass('grouped'))) {
				var relfiles = $(this).data('relfiles');
				var $actualFile = $(this);
				$actualFile.addClass('grouped').addClass('border-top');
				var firstItem = true;
				$.each(relfiles, function(i, v) {
					var $file = $table.find('#file-'+v);
					if ($file.length) {
						$file.insertAfter($actualFile).addClass('grouped');
						if (firstItem) {
							firstItem = false;
							$file.addClass('border-bottom');
						}
					}
				});
			}
		});
	});
}

/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
if (window.q) {
	window.q.forEach((f) => {
		$(f);
	});
}



// WEBPACK FOOTER //
// ./fe/web-gmeinder/src/js/web.js